<template>
    <div>
        <el-dialog v-bind="$attrs" width="1000px" :visible.sync="open" :title="title" append-to-body v-on="$listeners">
            <!-- 表格 -->
            <el-form>
                <el-form-item>
                    <el-button @click="importSchoolCalendar">导入校历</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="loading" :data="this.termList">
                <el-table-column prop="week" label="周别" header-align="center" align="center"></el-table-column>
                <el-table-column prop="startDate" label="起始时间" header-align="center" align="center"></el-table-column>
                <el-table-column prop="endDate" label="结束时间" header-align="center" align="center"></el-table-column>
                <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.teacherClassList !== null" size="mini" type="text" icon="el-icon-edit"
                            @click="modify(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 修改弹窗 -->
        <el-dialog v-bind="$attrs" width="500px" :visible.sync="modifyOpen" title="修改" append-to-body v-on="$listeners">
            <el-form style="margin-left:50px">
                <el-date-picker
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
            </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitForm">确 定</el-button>
                    <el-button @click="cancel">取 消</el-button>
                </div>
        </el-dialog>
        <!-- 导入按钮 -->
        <import-school-calendar ref="importSchoolCalendar"></import-school-calendar>
    </div>
</template>
<script>
import ImportSchoolCalendar from './import-school-calendar'
import Cookies from 'js-cookie'
export default {
    data() {
        return {
            //周数
            week:'',
            //修改时间的容器
            time:[],
            //开始时间
            startDate:'',
            //结束时间
            endDate:'',
            //校历设置按钮标题
            title:'',
            //弹窗
            modifyOpen:false,
            open: false,
            //遮罩层
            loading: false,
            //校历设置
            termList:[],
            termData:{
                termName:'',
                termId:'',
                schoolId:''
            }
        }
    },
    methods: {
        // 初始化
        init() {
            this.title = this.termData.termName + "校历设置"
            this.open = true
            this.getList()
            console.log(this.termData)
        },
        getList(){
            const params = {
                    token: Cookies.get('token'),
                    schoolId: this.termData.schoolId,
                    termId: this.termData.termId
            }
            this.$http
                .get('/schoolcalendar/schoolcalendarprimary/getSchoolCalendarWeek', {params})
                .then(({ data: res }) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg);
                    }
                    console.log(res.data);
                    this.termList = res.data
                   
                });
        },
        //导入按钮
        importSchoolCalendar(){
            this.open = false
            this.$nextTick(() => {
            this.$refs.importSchoolCalendar.dataForm.termId = this.termData.termId
            this.$refs.importSchoolCalendar.dataForm.schoolId = this.termData.schoolId
            this.$refs.importSchoolCalendar.init()
            })
        },
        //修改按钮
        modify(row){
            this.modifyOpen = true
            this.week = row.week
            this.startDate = row.startDate
            this.endDate = row.endDate
            this.time = []
            this.time.push(this.startDate)
            this.time.push(this.endDate)
        },
        //修改确定按钮
        submitForm(){
            this.modifyOpen = false
            const date = new Date(this.time[0])
            this.startDate =
                date.getFullYear() +
                '-' +
                (date.getMonth() + 1) +
                '-' +
                date.getDate() +
                ' ' +
                '00:00:00'
            const date2 = new Date(this.time[1])
            this.endDate =
                date2.getFullYear() +
                '-' +
                (date2.getMonth() + 1) +
                '-' +
                date2.getDate() +
                ' ' +
                '23:59:59'
            console.log(this.time)
            const modifyList  = {
                token: Cookies.get('token'),
                startDate:this.startDate,
                endDate:this.endDate,
                week:this.week,
                schoolId:this.termData.schoolId,
                termId:this.termData.termId
            }
            console.log(modifyList)
            this.$http
                .post('/schoolcalendar/schoolcalendarprimary/updateSchoolCalendarWeek ', modifyList)
                .then(({ data: res }) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg);
                    }
                    console.log(res.data);
                    this.getList()
                   
                });
        },
        //取消按钮
        cancel(){
            this.modifyOpen = false
        },

        test(){
            console.log('this.startDate',this.startDate)
            console.log('this.endDate',this.endDate)
        }

    },
    components: {
    ImportSchoolCalendar
  },
}
</script>